import {
  AIExtractedFieldCard as SharedAIExtractedFieldCard,
  type AIExtractedFieldCardProps as SharedProps,
} from "@platform/btx-grid-components";
import { useNotification } from "@platform/hooks";
import React, { useCallback } from "react";

import { useApiClient } from "../api/useApiClient";

export type {
  AIExtractedRow,
  FieldSource,
} from "@platform/btx-grid-components";

export type AIExtractedFieldCardProps = Omit<
  SharedProps,
  "axiosInstance" | "onError"
>;

/**
 * Plan-designer wrapper around the shared AIExtractedFieldCard.
 * Provides the axios instance from PlanEditor context and routes
 * errors through the notification system.
 */
export const AIExtractedFieldCard: React.FC<AIExtractedFieldCardProps> = (
  props,
): React.JSX.Element => {
  const axiosInstance = useApiClient();
  const { showError } = useNotification();

  const handleError = useCallback(
    (message: string) => showError(message, false),
    [showError],
  );

  return (
    <SharedAIExtractedFieldCard
      {...props}
      axiosInstance={axiosInstance}
      onError={handleError}
    />
  );
};
